import Swal from "sweetalert2";
import UsersApi from "../Classes/API/UsersApi";
import SearchUserReq from "../Classes/Models/Requests/Users/SearchUser";

export const sendAppointmentWhatsapp = async ({
  patientId,
  AppHour,
  isDummy,
  pName,
  sName,
  swalConfig = {},
}) => {
  let req = new SearchUserReq();
  req.patientId = patientId;

  try {
    let res = await UsersApi.SearchUsers(req);

    if (res.status === "Success" && res.data.list.length > 0) {
      const patient = res.data.list[0];
      const phone = patient.number.replace(/[^\d]/g, "");

      const finalPatientName = isDummy ? pName : patient.name;
      const finalSessionName = sName.split(" -")[0];

      const appointmentDate = new Date(AppHour.appointmentHourTime);
      let hours = appointmentDate.getHours();
      const minutes = appointmentDate.getMinutes().toString().padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;

      const message = `Dear ${finalPatientName}, this is an automated message from Elagi Center to confirm your appointment at ${hours}:${minutes} ${ampm} on ${appointmentDate.toLocaleDateString()} with ${AppHour.therapistName} for ${finalSessionName}. Please let us know at least 24 hours in advance if you want make any changes. Thank you.`;

      const url = `https://web.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");
    } else {
      Swal.fire({
        ...swalConfig,
        title: "Failed to fetch contact info",
        text: res.message || "User not found",
        icon: "error",
      });
    }
  } catch (error) {
    Swal.fire({
      ...swalConfig,
      title: "Error",
      text: "Could not connect to the server to fetch user details.",
      icon: "error",
    });
  }
};
